import React, { useCallback, useEffect, useState } from "react";
import Map, { Source, Layer, Marker, Popup, NavigationControl } from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import axios from "axios";
import { URL_BASE } from "../../config/url-server";
import { Divider, Spin } from "antd";
import config from "../../config/config";
import { es } from "date-fns/locale/es";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import reportServices from "../../services/report-services";

import farmService from "../../services/farm-service";
import sectionService from "../../services/section-service";
import lotService from "../../services/lot-service";
import mapServices from "../../services/map-services";

import { ToastContainer, toast } from 'react-toastify';
import DatePicker from "react-datepicker";

import moment from "moment";

import { Controller, useForm } from "react-hook-form";
import HeatMapZones from "./MapComponent/HeatMapZones";

const MapFirstApplicationHeatMap = () => {



    const [popup, setPopup] = useState(null);

    const colorCero = "#ff0000"
    const colorOne = "#FF8000"
    const colorTwo = "#FFFF66"
    const colorThree = "#80DFFF"
    const colorFour = "#3333FF"

    const [title, setTitle] = useState("Finca - Lote");

    const [viewState, setViewState] = useState({
        latitude: 5.391078, // Se actualizará dinámicamente
        longitude: -73.869958, // Se actualizará dinámicamente
        zoom: 5, // Zoom inicial
    });


    const [lotId, setLotId] = useState("0");
    const [farmId, setFarmId] = useState("0");
    const [sectionId, setSectionId] = useState("0");
    const [selectedPoint, setSelectedPoint] = useState(null); // Punto seleccionado para el popup
    const [lotPalmsLayer, setLotPalmsLayer] = useState(null);
    const [mapLoaded, setMapLoaded] = useState(false);
    const [centerMap, setCenterMap] = useState({ lat: 10.5582, lng: -74.1915 });
    const [markerData, setMarkerData] = useState([]);
    const [popupInfo, setPopupInfo] = useState(null);
    const [loading, setLoading] = useState(false);

    const clientId = localStorage.getItem("client");
    const accessToken = localStorage.getItem("token");

    const [monthOffset, setMonthOffset] = useState(-1);



    registerLocale("es", es);
    //const start_date = moment().add(-config.DAYS_LESS_MAP, 'd').startOf("day").toDate();
    //const end_date = moment().endOf("day").toDate();


    const start_date = moment().subtract(1, 'month').startOf('month').toDate();
    const end_date = moment().subtract(1, 'month').endOf('month').toDate();

    const [startDate, setStartDate] = useState(start_date);
    const [endDate, setEndDate] = useState(end_date);

    const [lotPalms, setLotPalms] = useState([]); // Puntos de todas las palmas del lote    
    const escoja = [{ _id: 0, name: "-ESCOJA-" }];
    const [listSection, setListSection] = useState(escoja);
    const [listFarms, setListFarms] = useState(escoja);
    const [listLots, setListLots] = useState(escoja);
    const [listPalms, setListPalms] = useState(escoja);
    const [tileset, setTileset] = useState(null);
    const [initFLag, setInitFlag] = useState(false);






    const {
        register,
        getValues,
        setValue,
        control,
        formState: { errors },
    } = useForm();



    const handleMapClick = useCallback((event) => {
        const feature = event.features && event.features[0];
        if (feature) {

            console.log("feature", feature)
            setPopup({
                coordinates: feature.geometry.coordinates,
                palmName: feature.properties.palmName,
                lineName: feature.properties.lineName,
                total: feature.properties.total,
            });
        }
    }, []);


    const getLisFarm = async () => {
        if (farmId == "0") {
            let listado = await farmService.getList();
            if (listado) {
                listado.push({ _id: 0, name: "-ESCOJA-" });
                const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
                setListFarms(sortedItems);
                //setValue("farm",0)
            }
        }
    };




    const getListSection = async (e) => {
        const code = e.target.value;
        if (code == "0") {
            setListSection(escoja);
            setListLots(escoja);
            setValue("section", "0")
            setValue("lot", "0")
            setValue("user", "0")
            return;
        }
        let listado = await sectionService.getListByFarm(code);
        listado.push({ _id: 0, name: "-ESCOJA-" });
        if (listado) {
            const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
            setListSection(sortedItems);
            setValue("section", "0")
            setValue("lot", "0")
            setValue("user", "0")
        }
    };



    const getLisLots = async (e) => {
        const code = e.target.value;
        if (code == "0") {
            setListLots(escoja);
            setValue("lot", "0")
            setValue("user", "0")
            return;
        }
        let listado = await lotService.getListBySection(code);
        listado.push({ _id: 0, name: "-ESCOJA-" });
        if (listado) {
            const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
            setListLots(sortedItems);
            setValue("lot", "0")
            setValue("user", "0")
        }
    };




    const generateExcel = async () => {

        const farmId = getValues("farm");
        const sectionId = getValues("section");
        const lotId = getValues("lot");
        if (lotId == "0") {
            toast.error("Seleccione un lote", { autoClose: 1600 })
            return;
        }

        setLoading(true);
        try {
            let start_date = getValues("startDate")
            let end_date = getValues("endDate")
            const start = moment(start_date).startOf("day").format('YYYY-MM-DD');
            const end = moment(end_date).endOf("day").format('YYYY-MM-DD');
            const userId = "0"
            const response = await reportServices.generateFirstApplicationMapExcel(start, end, farmId, sectionId, lotId, userId);

            if (response?.error) {
                toast.error("No hay registros", { autoClose: 1600 })
                setLoading(false);
                return;
            }


            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Inflorescencias de primera ${start} - ${end}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();

        } catch (error) {
            setLoading(false);
        } finally {
            setLoading(false);
        }
    }











    const searchPalms = async () => {

        setInitFlag(true)

        const farmId = getValues("farm");
        const sectionId = getValues("section");
        const lotId = getValues("lot");
        if (lotId == "0") {
            toast.error("Seleccione un lote", { autoClose: 1600 })
            return;
        }
        let start_date = getValues("startDate")
        let end_date = getValues("endDate")
        console.log("start_date", start_date)
        console.log("end_date", end_date)
        const start = moment(start_date).startOf("day").format('YYYY-MM-DD');
        const end = moment(end_date).endOf("day").format('YYYY-MM-DD');
        setLoading(true);

        try {
            const response = await mapServices.mapFirstApplication(start, end, farmId, sectionId, lotId)
            const palms = response.data;

            const tilesetWeb = response.tileset;
            const latitude = response.latitude;
            const longitude = response.longitude;
            setTileset(tilesetWeb)

            console.log(palms.length)
            if (latitude) {
                setCenterMap({ latitude, longitude });
                setViewState({
                    latitude: latitude,
                    longitude: longitude,
                    zoom: 17,
                });
            }
            else {
                if (palms.length > 0) {
                    const middle = Math.floor(palms.length / 2);
                    const coords = palms[middle]?.location?.coordinates;

                    if (coords && coords.length === 2) {
                        const lat = coords[1];
                        const lng = coords[0];
                        setCenterMap({ lat, lng });

                        setViewState({
                            latitude: lat,
                            longitude: lng,
                            zoom: 17,
                        });
                    }
                }
            }


            setMarkerData(palms);

        } catch (error) {
            console.error("Error obteniendo las palmas:", error);
        } finally {
            setLoading(false);
        }
    };


    const isValidCoordinate = (coord) => {


        return (
            Array.isArray(coord) &&
            coord.length === 2 &&
            typeof coord[0] === 'number' &&
            typeof coord[1] === 'number' &&
            !isNaN(coord[0]) &&
            !isNaN(coord[1])
        );
    };



    const setDates = (value) => {
        const currentStart = getValues("startDate");
        const base = moment(currentStart);

        const newStart = base.clone().add(value, 'month').startOf('month').toDate();
        const newEnd = base.clone().add(value, 'month').endOf('month').toDate();

        setValue("startDate", newStart);
        setValue("endDate", newEnd);

        setStartDate(newStart);
        setEndDate(newEnd);

        searchPalms();
    };




    useEffect(() => {
        console.log("se ejecuta el useeffect inicial")
        const farm_name = localStorage.getItem("farmName");
        const lot_name = localStorage.getItem("lotName");
        setTitle(`FINCA ${farm_name} - ${lot_name}`);
        getLisFarm();
        setValue("days", 190);
        // loadLotPositions();
    }, [markerData]);


    /*
        useEffect(() => {
            if (initFLag) {
                console.log("se ejecuta el useeffect del calendario")
               
                setStartDate(start_date);
                setEndDate(end_date);
               
            }
        }, [monthOffset]);*/

    return (
        <div >

            <ToastContainer />





            <div className="row">


                <div className="col-12 col-sm-2">

                    <div className="col-12 ml-4 ms-2" style={{ marginTop: "-10px" }}>
                        <Divider orientation="left" style={{ border: "#AAAAAA" }} >Flores de primera</Divider>
                    </div>

                    <form className="form-react"
                    >
                        <div className="row ms-2">



                            <div className=" col-12">
                                <label className="text-secondary fw-bold">Finca</label>
                                <select
                                    className="form-control text-secondary"

                                    {...register("farm")}
                                    onChange={(e) => getListSection(e)}
                                >
                                    {listFarms.map((option) => (
                                        <option key={option._id} value={option._id}>
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </div>


                            <div className="  col-12 col-sm-12">
                                <label className="text-secondary fw-bold">Sección</label>
                                <select
                                    className="form-control text-secondary"
                                    {...register("section")}
                                    {...register("section")}
                                    onChange={(e) => getLisLots(e)}
                                >
                                    {listSection.map((option) => (
                                        <option key={option._id} value={option._id}>
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className=" col-12">
                                <label className="text-secondary fw-bold">Lote</label>
                                <select
                                    className="form-control text-secondary"
                                    {...register("lot")}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setLotId(value);
                                    }}
                                >
                                    {listLots.map((option) => (
                                        <option key={option._id} value={option._id}>
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </div>


                            <div className="col-12">
                                <label className="text-secondary fw-bold">Desde</label>
                                <br />
                                <Controller
                                    control={control}
                                    name="startDate"
                                    defaultValue={startDate}
                                    render={({ field }) => (
                                        <DatePicker
                                            {...field}
                                            locale="es"
                                            dateFormat="yyyy-MM-dd"
                                            className="form-control text-secondary"
                                            selected={field.value}
                                            onChange={(date) => {
                                                field.onChange(date); 
                                                const endOfMonth = moment(date).endOf("month").toDate();
                                                setValue("endDate", endOfMonth);
                                                setEndDate(endOfMonth);
                                            }}
                                        />
                                    )}
                                />
                            </div>

                            <div className="col-12">
                                <label className="text-secondary fw-bold">Hasta</label>
                                <br />
                                <Controller
                                    control={control}
                                    name="endDate"
                                    defaultValue={endDate}
                                    render={({ field }) => (
                                        <DatePicker
                                            {...field}
                                            locale="es"
                                            dateFormat="yyyy-MM-dd"
                                            className="form-control text-secondary"
                                            selected={field.value}
                                            onChange={(date) => field.onChange(date)} // 👈 necesario
                                        />
                                    )}
                                />
                            </div>


                            <div className=" col-12">
                                <label className="text-secondary fw-bold">&nbsp;</label>
                                <br />
                                <Spin spinning={loading}>
                                    <button
                                        className="btn btn-primary w-100"
                                        type="button"
                                        onClick={() => searchPalms()}
                                    >
                                        <i className="bi bi-search fa-lg m-2" /> Buscar
                                    </button>
                                </Spin>
                            </div>


                            <div className=" col-12 ">
                                <label className="text-secondary fw-bold">&nbsp;</label>
                                <br />
                                <Spin spinning={loading}>
                                    <button
                                        className="btn btn-info w-100"
                                        type="button"
                                        onClick={() => generateExcel()}
                                    >
                                        <i className="bi bi-file-earmark-text fa-lg m-2" /> Exportar
                                    </button>
                                </Spin>
                            </div>




                            <div className=" col-6 mb-4">
                                <label className="text-secondary fw-bold">&nbsp;</label>
                                <br />
                                <Spin spinning={loading}>
                                    <button
                                        className="btn btn-info w-100"
                                        type="button"
                                        onClick={() => setDates(- 1)}
                                    >
                                        <i className="bi bi-skip-backward fa-lg m-2" />
                                    </button>
                                </Spin>
                            </div>




                            <div className=" col-6 mb-4">
                                <label className="text-secondary fw-bold">&nbsp;</label>
                                <br />
                                <Spin spinning={loading}>
                                    <button
                                        className="btn btn-info w-100"
                                        type="button"
                                        onClick={() => setDates(1)}
                                    >
                                        <i className="bi bi-skip-forward fa-lg m-2" />
                                    </button>
                                </Spin>
                            </div>



                        </div>
                    </form>





                    <div className="col-12 m-3">

                        <h6 style={{ fontWeight: "bold", marginBottom: "8px" }}>Leyenda de colores</h6>
                        <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }} className="d-none">
                                <span style={{ width: "20px", height: "20px", backgroundColor: colorCero, border: "1px solid #aaa", borderRadius: "4px" }}></span>
                                <span>0 - Inflorescencias</span>
                            </div>

                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <span style={{ width: "20px", height: "20px", backgroundColor: colorOne, border: "1px solid #aaa", borderRadius: "4px" }}></span>
                                <span>1 Inflorescencia</span>
                            </div>

                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <span style={{ width: "20px", height: "20px", backgroundColor: colorTwo, border: "1px solid #aaa", borderRadius: "4px" }}></span>
                                <span>2 Inflorescencias</span>
                            </div>

                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <span style={{ width: "20px", height: "20px", backgroundColor: colorThree, border: "1px solid #aaa", borderRadius: "4px" }}></span>
                                <span>3 Inflorescencias</span>
                            </div>

                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <span style={{ width: "20px", height: "20px", backgroundColor: colorFour, border: "1px solid #aaa", borderRadius: "4px" }}></span>
                                <span>4 o más Inflorescencias</span>
                            </div>

                        </div>

                    </div>




                </div>




                <div className="col-12 col-sm-10">
                    <Map
                        {...viewState} // Aplicar el estado de la vista dinámica
                        onMove={evt => setViewState(evt.viewState)} // Permitir mover el mapa
                        style={{ width: "100%", height: "100vh" }}
                        mapStyle="mapbox://styles/mapbox/satellite-v9" // Mapa satelital
                        mapboxAccessToken="pk.eyJ1IjoianVhbmNwaW5lZGFtIiwiYSI6ImNtNXlyNmxtbjBubm0ya3B5ZHVnMWgwcWYifQ.dogzl3DX9PMO9QywZ8CbyA"
                        interactiveLayerIds={["palms-layer"]}
                        onClick={handleMapClick}
                    >

                        <NavigationControl position="top-left" />







                        <HeatMapZones palms={markerData} tileset={tileset}></HeatMapZones>
                        {popup && (
                            <Popup
                                longitude={popup.coordinates[0]}
                                latitude={popup.coordinates[1]}
                                anchor="top"
                                onClose={() => setPopup(null)}
                                closeOnClick={false}
                            >
                                <div>
                                    <strong>Línea:</strong> {popup.lineName}<br />
                                    <strong>Palma:</strong> {popup.palmName} <br />
                                    <strong>total:</strong> {popup.total}
                                </div>
                            </Popup>
                        )}





                    </Map>

                </div>



            </div>




        </div>
    );
};

export default MapFirstApplicationHeatMap;
